import { Chip, Tooltip, Typography } from '@mui/material';
import { formatFlexworkerCount } from 'shared/utils/formatting';
import { Column } from 'react-table';
import { LevelTableCellProps, TableCell, TableHeader } from 'redesign';
import { TFunctionNonStrict } from 'i18next';
import { FlexPoolsTableColumnDefinition } from './flex-pools-table.types';

export const getFlexPoolsColumnDefinition = (
  t: TFunctionNonStrict<'ogp-screen-specific', undefined>
): Column<FlexPoolsTableColumnDefinition>[] => {
  const flexpool: Column<FlexPoolsTableColumnDefinition> = {
    accessor: 'flexPoolName',
    Header: () => (
      <TableHeader>
        {t('flexpools.table_headers.flexpool', { ns: 'ogp-screen-specific' })}
      </TableHeader>
    ),
    Cell: ({ value }) => <TableCell>{value}</TableCell>,
  };

  const branchOffice: Column<FlexPoolsTableColumnDefinition> = {
    accessor: 'departmentNames',
    Header: () => (
      <TableHeader>
        {t('flexpools.table_headers.departments', { ns: 'ogp-screen-specific' })}
      </TableHeader>
    ),
    Cell: DepartmentsCell,
    width: 600,
  };

  const flexWorkerCount: Column<FlexPoolsTableColumnDefinition> = {
    accessor: 'flexWorkerCount',
    Header: () => (
      <TableHeader>
        {t('flexpools.table_headers.flexworkers', { ns: 'ogp-screen-specific' })}
      </TableHeader>
    ),
    Cell: ({ value }) => <TableCell>{formatFlexworkerCount(value)}</TableCell>,
  };

  return [flexpool, branchOffice, flexWorkerCount];
};

const DepartmentsCell = ({
  value,
}: LevelTableCellProps<
  FlexPoolsTableColumnDefinition,
  FlexPoolsTableColumnDefinition['departmentNames']
>) => {
  const depLen = value.length;
  const extraDepartments = value.slice(4).join(', ');

  return (
    <TableCell style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      {value.slice(0, 4).map((department, index) => (
        <Chip key={index} label={department} style={{ marginBottom: 0 }} />
      ))}
      {depLen > 4 && (
        <Tooltip title={extraDepartments}>
          <Typography variant="body2">{`+${depLen - 4} afdelingen`}</Typography>
        </Tooltip>
      )}
    </TableCell>
  );
};
